/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertCMASubjectPropertyByMlsIdRequestDto
 */
export interface UpsertCMASubjectPropertyByMlsIdRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertCMASubjectPropertyByMlsIdRequestDto
     */
    mlsId: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertCMASubjectPropertyByMlsIdRequestDto
     */
    id?: string;
}

/**
 * Check if a given object implements the UpsertCMASubjectPropertyByMlsIdRequestDto interface.
 */
export function instanceOfUpsertCMASubjectPropertyByMlsIdRequestDto(value: object): value is UpsertCMASubjectPropertyByMlsIdRequestDto {
    if (!('mlsId' in value) || value['mlsId'] === undefined) return false;
    return true;
}

export function UpsertCMASubjectPropertyByMlsIdRequestDtoFromJSON(json: any): UpsertCMASubjectPropertyByMlsIdRequestDto {
    return UpsertCMASubjectPropertyByMlsIdRequestDtoFromJSONTyped(json, false);
}

export function UpsertCMASubjectPropertyByMlsIdRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertCMASubjectPropertyByMlsIdRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'mlsId': json['mlsId'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function UpsertCMASubjectPropertyByMlsIdRequestDtoToJSON(json: any): UpsertCMASubjectPropertyByMlsIdRequestDto {
    return UpsertCMASubjectPropertyByMlsIdRequestDtoToJSONTyped(json, false);
}

export function UpsertCMASubjectPropertyByMlsIdRequestDtoToJSONTyped(value?: UpsertCMASubjectPropertyByMlsIdRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mlsId': value['mlsId'],
        'id': value['id'],
    };
}

